import { NavLink } from "react-router-dom";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Billing health indicator shown in the sidebar. Links to /credits?manage=1 which
// auto-opens the Stripe Customer Portal so users can view/fix their payment details.
export function AccountStatusButton() {
  const { user } = useAuth();
  const status = user?.subscription_status;
  const plan = user?.plan || "free";
  const needsAttention = status === "past_due";
  const paidUp = status === "active" && plan !== "free";
  if (!needsAttention && !paidUp) return null;

  const renewDate = user?.current_period_end
    ? new Date(user.current_period_end).toLocaleDateString("en-US", { month: "short", day: "numeric" })
    : null;

  if (needsAttention) {
    return (
      <NavLink
        to="/credits?manage=1"
        data-testid="account-status-attention"
        className="w-full mb-2 flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold bg-red-600/15 border border-red-500/40 text-red-300 hover:bg-red-600/25 transition-colors"
      >
        <AlertTriangle className="h-4 w-4 shrink-0" /> Account needs your attention
      </NavLink>
    );
  }
  return (
    <NavLink
      to="/credits?manage=1"
      data-testid="account-status-paid"
      className="w-full mb-2 flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold bg-emerald-600/15 border border-emerald-500/30 text-emerald-300 hover:bg-emerald-600/25 transition-colors"
    >
      <ShieldCheck className="h-4 w-4 shrink-0" />
      <span className="flex flex-col leading-tight">
        <span>Account paid up</span>
        {renewDate && (
          <span data-testid="account-status-renews" className="text-[11px] font-normal text-emerald-400/70">Renews {renewDate}</span>
        )}
      </span>
    </NavLink>
  );
}
